import React, { useContext, useState, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import visaLogo from '../../Images/payment_provider_images/visa.svg';
import mcLogo from '../../Images/payment_provider_images/mc.svg';
import amex from '../../Images/payment_provider_images/amex.svg';
import maestro from '../../Images/payment_provider_images/maestro.svg';
import googlePay from '../../Images/payment_provider_images/google-pay.svg';
import applePay from '../../Images/payment_provider_images/apple-pay.svg';
import poweredByStripe from '../../Images/payment_provider_images/powered_by_stripe.png';
import connectWithStripe from '../../Images/payment_provider_images/connect_with_stripe.png';
import '../../Styles/Payment.scss';
import useFetch from 'CustomHooks/useFetch';
import { GlobalContext } from '../../Contexts/GlobalContext';
import { isItTestEnvironment } from '../../Util/TestOrProd';
import CurrencySelector from './CurrencySelector';

export default function Payment__Configuration() {

  const [getAccountStatusResponse, getAccountStatus] = useFetch();
  const [accountConnected, setAccountConnected] = useState(false);
  const [connectedAccountId, setConnectedAccountId] = useState('');
  const globalContext = useContext(GlobalContext);
  const [putCustomerSettingsHookResponse, putCustomerSettingsHook] = useFetch();
  const [getCustomerSettingsHookResponse, getCustomerSettingsHook] = useFetch();
  const classes = useStyles();
  //const [clientId, setClientId] = useState('');

  const [stripeUrl, setStripeUrl] = useState('');

  useEffect(
    () => {
      let clientId = isItTestEnvironment() ? 'ca_GdDNct6BLaiQWE95fZg4QHTxCNqo15pM' : 'ca_GdDN33gCkyttS3bgGixLqUZArqv7HbqY';
      setStripeUrl("https://connect.stripe.com/oauth/authorize?response_type=code&client_id=" + clientId + "&scope=read_write");
    }, []
  )

  

  useEffect(
    () => {

      globalContext.dispatchMethod(
        {
          type: 'SET_MENU_LOCATION',
          value: {
            a: 8,
            b: 9,
          },
        }
      )

      globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
      getAccountStatus(
        {
          url: '/admin/stripe/get-account-status',
          addTokenHeader: true,
          method: 'GET',
          postData: null,
        }
      )
    }, []
  )

  useEffect(
    () => {
      console.log(getAccountStatusResponse);
      if (getAccountStatusResponse.length != 0 && getAccountStatusResponse) {
        if (getAccountStatusResponse.accountStatus == 'Connected') {
          setAccountConnected(true);
          setConnectedAccountId(getAccountStatusResponse.stripeUserId);
        }
      }
      globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
    }, [getAccountStatusResponse]
  )


  useEffect(
    () => {
      //window.gtag('config', 'UA-160225157-2', { 'page_path': '/PaymentConfiguration' });
    }, []
  )


  return (
    <React.Fragment>
      <CurrencySelector></CurrencySelector>
      <Paper elevation={3} style={{ padding: '10px', marginBottom: '30px' }}>
        <div>
          <div className="powered-by-stripe-container">
            <img src={poweredByStripe} className="powered-by-stripe-logo"></img>
          </div>
          <br></br>
          {
            accountConnected ?
              <p> You are connected and your Stripe account ID is:<b> {connectedAccountId}</b></p>
              :
              <React.Fragment>
                <p>
                  Click "Connect with Stripe" button below to enable STRIPE payment. You will be redirected to STRIPE site to complete the setup which will take a few minutes.
        </p>
                <br></br>
                <p>With STRIPE you will able to accept the following payment methods:</p>
                <br></br>
                <div>
                  <img src={visaLogo} className="payment-provider-logo"></img>
                  <img src={mcLogo} className="payment-provider-logo"></img>
                  <img src={maestro} className="payment-provider-logo"></img>
                  <img src={amex} className="payment-provider-logo"></img>
                  {/*
                    <img src={applePay} className="payment-provider-logo"></img>
                    <img src={googlePay} className="payment-provider-logo"></img>
                    */
                  }
                </div>

                <br></br>
                <br></br>
                <div>

                  <a href={stripeUrl}><img src={connectWithStripe} className="connect-with-stripe-image" ></img></a>
                </div>
              </React.Fragment>
          }

        </div>

      </Paper>
    </React.Fragment>
  );
}

const useStyles = makeStyles({
  
});
